export const commonEnvironment = {
  version: '0.0.1',
};
